export const THEME_TABLE_PER_ROW_LENGTH = 8; // 每条theme table数据8个字节

export const THEME_TABLE_PRE_LENGTH = 8; // v0.7.0 每个table添加两个字段

export const RECORD_LENGTH = 16;

export const THEME_EXTENDED_LENGTH = 72;

export const totalThemeRecordCount = new Array(100).fill(0);

export let _protocol = 8; // 协议版本

export const getProtocol = () => {
  // console.log('_protocol', _protocol);
  return _protocol;
};

export const getThemeTableTotalCount = () => {
  const protocol = getProtocol();
  if (protocol > 8) {
    // console.log('themetabletotalcount', 12, protocol);
    return 12;
  } else {
    // console.log('themetabletotalcount', 10, protocol);
    return 10;
  }
};

export const getThemeTableLength = () =>
  THEME_TABLE_PRE_LENGTH +
  getThemeTableTotalCount() * THEME_TABLE_PER_ROW_LENGTH;

export const getThemePreLength = () => getThemeTableLength();

export const updateProtocol = (protocol: number) => {
  _protocol = protocol;
};
